export const CHART = 'CHART';